import { Logger, LogMetadata } from './Logger';

export class MultiLogger implements Logger {
  constructor(private readonly loggers: Logger[]) {
    // empty
  }

  debug(message: string, metadata?: LogMetadata): void {
    this.loggers.forEach(logger => logger.debug(message, metadata));
  }

  error(message: string, metadata?: LogMetadata): void {
    this.loggers.forEach(logger => logger.error(message, metadata));
  }

  info(message: string, metadata?: LogMetadata): void {
    this.loggers.forEach(logger => logger.info(message, metadata));
  }

  warn(message: string, metadata?: LogMetadata): void {
    this.loggers.forEach(logger => logger.warn(message, metadata));
  }

  setDefaultMetadata(metadata: LogMetadata): void {
    this.loggers.forEach(logger => logger.setDefaultMetadata(metadata));
  }
}

export const createMultiLogger = (loggers: Logger[]) => {
  return new MultiLogger(loggers);
};
